import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { resetPassword } from "../../../core/data/redux/auth/authAction";
import { all_routes } from "../../router/all_routes";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { AppDispatch } from "../../../core/data/redux/store";
import { message } from "antd";

const ResetPassword = () => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const routes = all_routes;
  const { forgotUserData } = useSelector(
    (state: any) => state.auth
  );

  // State to manage password visibility and values
  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
    confirmPassword: false,
  });
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [otp, setOtp] = useState("");

  // Validation function for OTP and Password
  const validateForm = () => {
    if (otp.length !== 6) {
      message.error("OTP must be 6 digits long.");
      return false;
    }
    if (password.length < 8) {
      message.error("Password must be at least 8 characters long.");
      return false;
    }
    if (password !== confirmPassword) {
      message.error("Passwords do not match.");
      return false;
    }
    return true;
  };

  // Dispatch resetPassword action on form submission
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // Validate the form before submitting
    if (!validateForm()) {
      return; // Exit if validation fails
    }

    // Prepare payload to reset password
    const payload = {
      email: forgotUserData.data.email,
      subscription_id: forgotUserData.data.subscription_id, 
      configID: forgotUserData.data.configID, 
      otp,
      newPassword: password,
    };

    dispatch(resetPassword(payload))
      .unwrap()
      .then(() => {
        message.success("Password reset successful. Redirecting to success page.");
        navigate(routes.resetPasswordSuccess);
      })
      .catch((err: string) => {
        message.error(err); // Handle error if action fails
      });
  };

  const togglePasswordVisibility = (field: "password" | "confirmPassword") => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>, field: "password" | "confirmPassword") => {
    const value = e.target.value;
    if (field === "password") {
      setPassword(value);
    } else {
      setConfirmPassword(value);
    }
  };

  return (
    <div className="container-fluid">
      <div className="d-flex flex-wrap vh-100">
        <div className="col-lg-5">
          <div className="login-background position-relative d-lg-flex align-items-center justify-content-center d-none flex-wrap vh-100">
            <div className="bg-overlay-img">
              <ImageWithBasePath src="assets/img/bg/bg-01.png" className="bg-1" alt="Img" />
              <ImageWithBasePath src="assets/img/bg/bg-02.png" className="bg-2" alt="Img" />
              <ImageWithBasePath src="assets/img/bg/bg-03.png" className="bg-3" alt="Img" />
            </div>
            <div className="authentication-card w-100">
              <div className="authen-overlay-item border w-100">
                <h1 className="text-white display-1">
                  Empowering people <br /> through seamless HR <br /> management.
                </h1>
                <div className="my-4 mx-auto authen-overlay-img">
                  <ImageWithBasePath src="assets/img/bg/authentication-bg-001.svg" alt="Img" />
                </div>
                <div>
                  <p className="text-white fs-20 fw-semibold text-center">
                    Efficiently manage your workforce, streamline <br /> operations effortlessly.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-7 col-md-12 col-sm-12">
          <div className="row justify-content-center align-items-center vh-100">
            <div className="col-md-7 mx-auto vh-100">
              <form onSubmit={handleSubmit}>
                <div className="d-flex flex-column justify-content-between p-4 pb-0 vh-100">
                  <div className="text-center mb-5">
                    <ImageWithBasePath src="assets/img/hrmtreelogo.svg" className="img-fluid" alt="Logo" />
                  </div>
                  <div className="text-center mb-3">
                    <h2 className="mb-2">Reset Password</h2>
                    {/* <p className="mb-0">Your new password must be different from previously used passwords.</p> */}
                  </div>
                  <div>
                    <div className="input-block mb-3">
                      <label className="form-label">Reset OTP</label>
                      <div className="input-group">
                        <input
                          type="text"
                          name="email_otp"
                          value={otp}
                          onChange={(e) => setOtp(e.target.value)}
                          placeholder="Enter OTP"
                          className="form-control border-end-0"
                        />
                        <span className="input-group-text border-start-0">
                          <i className="ti ti-key" />
                        </span>
                      </div>
                    </div>

                    <div className="input-block mb-3">
                      <label className="form-label">Password</label>
                      <div className="pass-group">
                        <input
                          type={passwordVisibility.password ? "text" : "password"}
                          value={password}
                          onChange={(e) => handlePasswordChange(e, "password")}
                          className="form-control pass-input"
                          placeholder="Enter your password"
                        />
                        <span
                          className={`ti toggle-passwords ${passwordVisibility.password ? "ti-eye" : "ti-eye-off"}`}
                          onClick={() => togglePasswordVisibility("password")}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    </div>

                    <div className="input-block mb-3">
                      <label className="form-label">Confirm Password</label>
                      <div className="pass-group">
                        <input
                          type={passwordVisibility.confirmPassword ? "text" : "password"}
                          value={confirmPassword}
                          onChange={(e) => handlePasswordChange(e, "confirmPassword")}
                          className="form-control pass-input"
                          placeholder="Confirm your password"
                        />
                        <span
                          className={`ti toggle-passwords ${passwordVisibility.confirmPassword ? "ti-eye" : "ti-eye-off"}`}
                          onClick={() => togglePasswordVisibility("confirmPassword")}
                          style={{ cursor: "pointer" }}
                        />
                      </div>
                    </div>

                    <div className="mb-3">
                      <button type="submit" className="btn btn-primary w-100">
                        Submit
                      </button>
                    </div>
                  </div>

                  <div className="mt-5 pb-4 text-center">
                    <p className="mb-0 text-gray-9">Copyright © 2024 - hrmtree</p>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
